// extracted by mini-css-extract-plugin
export default {"root":"styles_root__NGLdb","title":"styles_title__JHYKP","innards":"styles_innards__QVIkA","payTable":"styles_payTable__+fVtN","cards":"styles_cards__9XZKb"};